export const slides = [
  {
    id: 'slide-1',
    title: '적벽가',
    caption: '공연 장면',
    image: '/logo512.png',
  },
  {
    id: 'slide-2',
    title: '흥보가',
    caption: '완창 하이라이트',
    image: '/logo192.png',
  },
]; 